// Airlines that operate regular commercial service in Brazil.
// IATA code + display name.
export const BR_AIRLINES = [
  { iata: "LA", name: "LATAM Airlines" },
  { iata: "G3", name: "GOL" },
  { iata: "AD", name: "Azul" },
  { iata: "2Z", name: "Voepass" },
  { iata: "O6", name: "Avianca (Brasil)" },
  { iata: "FO", name: "Flybondi" },
  { iata: "JA", name: "JetSmart" },
  { iata: "AA", name: "American Airlines" },
  { iata: "UA", name: "United Airlines" },
  { iata: "DL", name: "Delta Air Lines" },
  { iata: "AF", name: "Air France" },
  { iata: "KL", name: "KLM" },
  { iata: "LH", name: "Lufthansa" },
  { iata: "IB", name: "Iberia" },
  { iata: "TP", name: "TAP Air Portugal" },
  { iata: "AR", name: "Aerolíneas Argentinas" },
  { iata: "CM", name: "Copa Airlines" },
  { iata: "AV", name: "Avianca" },
  { iata: "AM", name: "Aeroméxico" },
  { iata: "EK", name: "Emirates" },
  { iata: "QR", name: "Qatar Airways" },
  { iata: "ET", name: "Ethiopian Airlines" },
  { iata: "TK", name: "Turkish Airlines" },
  { iata: "BA", name: "British Airways" },
];

// Where the ticket was purchased. "direct" means bought straight from
// the airline; the rest are OTAs / travel agencies commonly used in Brazil.
export const BR_TRAVEL_AGENCIES = [
  { slug: "direct", name: "Direto com a companhia" },
  { slug: "decolar", name: "Decolar" },
  { slug: "maxmilhas", name: "MaxMilhas" },
  { slug: "123milhas", name: "123milhas" },
  { slug: "mytrip", name: "MyTrip" },
  { slug: "tripcom", name: "Trip.com" },
  { slug: "kiwi", name: "Kiwi.com" },
  { slug: "kayak", name: "Kayak" },
  { slug: "booking", name: "Booking.com" },
  { slug: "expedia", name: "Expedia" },
  { slug: "hurb", name: "Hurb" },
  { slug: "cvc", name: "CVC" },
  { slug: "submarino_viagens", name: "Submarino Viagens" },
  { slug: "viajanet", name: "ViajaNet" },
  { slug: "vai_de_promo", name: "Vai de Promo" },
  { slug: "zupper", name: "Zupper" },
  { slug: "almundo", name: "Almundo" },
  { slug: "skyscanner", name: "Skyscanner" },
  { slug: "other", name: "Outra agência" },
];

// Commercial airports in Brazil with regular passenger service.
// IATA + city (UF) + airport name.
export const BR_AIRPORTS = [
  { iata: "GRU", city: "São Paulo", uf: "SP", name: "Guarulhos" },
  { iata: "CGH", city: "São Paulo", uf: "SP", name: "Congonhas" },
  { iata: "VCP", city: "Campinas", uf: "SP", name: "Viracopos" },
  { iata: "SJK", city: "São José dos Campos", uf: "SP", name: "Prof. Urbano Ernesto Stumpf" },
  { iata: "RAO", city: "Ribeirão Preto", uf: "SP", name: "Leite Lopes" },
  { iata: "SDU", city: "Rio de Janeiro", uf: "RJ", name: "Santos Dumont" },
  { iata: "GIG", city: "Rio de Janeiro", uf: "RJ", name: "Galeão" },
  { iata: "CFB", city: "Cabo Frio", uf: "RJ", name: "Cabo Frio" },
  { iata: "CNF", city: "Belo Horizonte", uf: "MG", name: "Confins" },
  { iata: "PLU", city: "Belo Horizonte", uf: "MG", name: "Pampulha" },
  { iata: "IPN", city: "Ipatinga", uf: "MG", name: "Usiminas" },
  { iata: "UDI", city: "Uberlândia", uf: "MG", name: "Ten. Cel. Av. César Bombonato" },
  { iata: "UBA", city: "Uberaba", uf: "MG", name: "Mário de Almeida Franco" },
  { iata: "MOC", city: "Montes Claros", uf: "MG", name: "Mário Ribeiro" },
  { iata: "JDF", city: "Juiz de Fora", uf: "MG", name: "Presidente Itamar Franco" },
  { iata: "VIX", city: "Vitória", uf: "ES", name: "Eurico de Aguiar Salles" },
  { iata: "BSB", city: "Brasília", uf: "DF", name: "Juscelino Kubitschek" },
  { iata: "GYN", city: "Goiânia", uf: "GO", name: "Santa Genoveva" },
  { iata: "CGB", city: "Cuiabá", uf: "MT", name: "Marechal Rondon" },
  { iata: "CGR", city: "Campo Grande", uf: "MS", name: "Campo Grande" },
  { iata: "CWB", city: "Curitiba", uf: "PR", name: "Afonso Pena" },
  { iata: "LDB", city: "Londrina", uf: "PR", name: "Gov. José Richa" },
  { iata: "MGF", city: "Maringá", uf: "PR", name: "Silvio Name Júnior" },
  { iata: "FOZ", city: "Foz do Iguaçu", uf: "PR", name: "Cataratas" },
  { iata: "CAC", city: "Cascavel", uf: "PR", name: "Adalberto Mendes da Silva" },
  { iata: "POA", city: "Porto Alegre", uf: "RS", name: "Salgado Filho" },
  { iata: "CXJ", city: "Caxias do Sul", uf: "RS", name: "Hugo Cantergiani" },
  { iata: "PET", city: "Pelotas", uf: "RS", name: "Pelotas" },
  { iata: "URG", city: "Uruguaiana", uf: "RS", name: "Rubem Berta" },
  { iata: "FLN", city: "Florianópolis", uf: "SC", name: "Hercílio Luz" },
  { iata: "NVT", city: "Navegantes", uf: "SC", name: "Ministro Victor Konder" },
  { iata: "JOI", city: "Joinville", uf: "SC", name: "Lauro Carneiro de Loyola" },
  { iata: "CFC", city: "Chapecó", uf: "SC", name: "Serafin Enoss Bertaso" },
  { iata: "XAP", city: "Chapecó", uf: "SC", name: "Chapecó" },
  { iata: "SSA", city: "Salvador", uf: "BA", name: "Deputado Luís Eduardo Magalhães" },
  { iata: "IOS", city: "Ilhéus", uf: "BA", name: "Jorge Amado" },
  { iata: "BPS", city: "Porto Seguro", uf: "BA", name: "Porto Seguro" },
  { iata: "LEC", city: "Lençóis", uf: "BA", name: "Horácio de Mattos" },
  { iata: "VDC", city: "Vitória da Conquista", uf: "BA", name: "Glauber Rocha" },
  { iata: "REC", city: "Recife", uf: "PE", name: "Gilberto Freyre" },
  { iata: "FEN", city: "Fernando de Noronha", uf: "PE", name: "Fernando de Noronha" },
  { iata: "PNZ", city: "Petrolina", uf: "PE", name: "Sen. Nilo Coelho" },
  { iata: "MCZ", city: "Maceió", uf: "AL", name: "Zumbi dos Palmares" },
  { iata: "AJU", city: "Aracaju", uf: "SE", name: "Santa Maria" },
  { iata: "JPA", city: "João Pessoa", uf: "PB", name: "Pres. Castro Pinto" },
  { iata: "CPV", city: "Campina Grande", uf: "PB", name: "João Suassuna" },
  { iata: "NAT", city: "Natal", uf: "RN", name: "Aluízio Alves" },
  { iata: "FOR", city: "Fortaleza", uf: "CE", name: "Pinto Martins" },
  { iata: "JJD", city: "Jericoacoara", uf: "CE", name: "Jericoacoara" },
  { iata: "JDO", city: "Juazeiro do Norte", uf: "CE", name: "Orlando Bezerra de Menezes" },
  { iata: "THE", city: "Teresina", uf: "PI", name: "Sen. Petrônio Portella" },
  { iata: "PHB", city: "Parnaíba", uf: "PI", name: "Pref. Dr. João Silva Filho" },
  { iata: "SLZ", city: "São Luís", uf: "MA", name: "Mal. Cunha Machado" },
  { iata: "IMP", city: "Imperatriz", uf: "MA", name: "Pref. Renato Moreira" },
  { iata: "BEL", city: "Belém", uf: "PA", name: "Val de Cans" },
  { iata: "STM", city: "Santarém", uf: "PA", name: "Maestro Wilson Fonseca" },
  { iata: "MAB", city: "Marabá", uf: "PA", name: "João Correa da Rocha" },
  { iata: "ATM", city: "Altamira", uf: "PA", name: "Altamira" },
  { iata: "MAO", city: "Manaus", uf: "AM", name: "Eduardo Gomes" },
  { iata: "TBT", city: "Tabatinga", uf: "AM", name: "Tabatinga" },
  { iata: "TFF", city: "Tefé", uf: "AM", name: "Tefé" },
  { iata: "BVB", city: "Boa Vista", uf: "RR", name: "Atlas Brasil Cantanhede" },
  { iata: "PVH", city: "Porto Velho", uf: "RO", name: "Gov. Jorge Teixeira" },
  { iata: "RBR", city: "Rio Branco", uf: "AC", name: "Pres. Médici" },
  { iata: "CZS", city: "Cruzeiro do Sul", uf: "AC", name: "Cruzeiro do Sul" },
  { iata: "MCP", city: "Macapá", uf: "AP", name: "Alberto Alcolumbre" },
  { iata: "PMW", city: "Palmas", uf: "TO", name: "Brig. Lysias Rodrigues" },
  // Popular international destinations
  { iata: "JFK", city: "Nova York", uf: "US", name: "John F. Kennedy" },
  { iata: "MIA", city: "Miami", uf: "US", name: "Miami International" },
  { iata: "MCO", city: "Orlando", uf: "US", name: "Orlando International" },
  { iata: "LIS", city: "Lisboa", uf: "PT", name: "Humberto Delgado" },
  { iata: "CDG", city: "Paris", uf: "FR", name: "Charles de Gaulle" },
  { iata: "MAD", city: "Madrid", uf: "ES", name: "Barajas" },
  { iata: "LHR", city: "Londres", uf: "GB", name: "Heathrow" },
  { iata: "FRA", city: "Frankfurt", uf: "DE", name: "Frankfurt" },
  { iata: "EZE", city: "Buenos Aires", uf: "AR", name: "Ministro Pistarini" },
  { iata: "SCL", city: "Santiago", uf: "CL", name: "Arturo Merino Benítez" },
  { iata: "BOG", city: "Bogotá", uf: "CO", name: "El Dorado" },
  { iata: "PTY", city: "Cidade do Panamá", uf: "PA", name: "Tocumen" },
];
